import { CallStructuredSummaryStatus } from "@/types";

// Row tint. Positive and informational answers stay white so the eye is drawn
// to the exceptions.
export const stevieStatusRowClassName = (
  status: CallStructuredSummaryStatus,
) => {
  if (status === CallStructuredSummaryStatus.MAYBE) return "bg-amber-50/60";
  if (status === CallStructuredSummaryStatus.NO) return "bg-red-50/60";
  return undefined;
};

// Card tint. Cards are the top-line read, so every status gets a fill. INFO
// and UNKNOWN share the neutral grey.
export const stevieStatusCardClassName = (
  status: CallStructuredSummaryStatus,
) => {
  if (status === CallStructuredSummaryStatus.YES) return "bg-green-50";
  if (status === CallStructuredSummaryStatus.MAYBE) return "bg-amber-50";
  if (status === CallStructuredSummaryStatus.NO) return "bg-red-50";
  return "bg-slate-50";
};
